import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GameModeAction, GameModeState, Team} from '@app/state/game-mode.state';
import {Store} from '@ngxs/store';

@Component({
  selector: 'app-create-update-team-info-dialog',
  templateUrl: './team-info-control.component.html'
})
export class TeamInfoControlComponent implements OnInit {
  teams: Team[];
  usersList: { id: number; teamId: number; displayName: string }[];
  filteredUsersList: { id: number; teamId: number; displayName: string }[];
  isInCreateMode: boolean;
  currentActiveTabIndex = 0;
  currentTeamId: number;
  userShowMode: 'all' | 'selected' = 'all';


  constructor(public dialog: NgbActiveModal, private store: Store) {
  }

  ngOnInit(): void {
    this.currentTeamId = this.teams[0].id;
    this.filteredUsersList = this.getFilteredAndSortedUsers();
  }

  changeShowMode(showMode: 'all' | 'selected') {
    this.userShowMode = showMode;
    this.filteredUsersList = this.getFilteredAndSortedUsers();
  }

  getFilteredAndSortedUsers(): { id: number; teamId: number; displayName: string }[] {
    const filteredUsers = this.usersList.filter(user => {
      if (this.userShowMode === 'all') {
        return true;
      } else {
        return user.teamId !== -1 && this.currentTeamId === user.teamId;
      }

    });
    return filteredUsers.sort((a, b) => a.displayName.localeCompare(b.displayName));
  }

  addTeam() {
    if (this.teams.length <= 9) {
      /** Newly added Teams should be named based on the total number of added teams (even if removed). */
      this.store.dispatch(new GameModeAction.UpdateCreatedTeamsCounter());

      let localCounter = this.store.selectSnapshot(GameModeState).createdTeamsCounter;

      /** If a Team with name based on createdTeamsCounter already exist, locally increment the value */
      while (this.teams.some(team => team.name === `Team ${localCounter}`)) {
        localCounter++;
      }

      this.teams.push({
        name: 'Team ' + localCounter,
        id: this.teams[this.teams.length - 1].id + 1,
        participantIds: undefined,
        teamScore: 0,
        colorIndex: this.getColorIndexForNewTeam()
      });

      this.currentActiveTabIndex = this.teams.length - 1;
      this.currentTeamId = this.teams[this.teams.length - 1].id;
      this.userShowMode = 'all';
    }

  }

  /** Returns the first available color index in range of [1:9] for a new Team */
  getColorIndexForNewTeam(): number {
    const usedColors = new Set(this.teams.map(t => t.colorIndex));

    for (let i = 1; i <= 9; i++) {
      if (!usedColors.has(i)) {
        return i;
      }
    }
  }

  changeTeam(index) {
    this.currentActiveTabIndex = index;
    this.currentTeamId = this.teams[this.currentActiveTabIndex].id;
    this.userShowMode = 'all';
  }

  removeCurrentTeam() {
    this.teams.splice(this.currentActiveTabIndex, 1);

    for (const user of this.usersList) {
      if (user.teamId === this.currentTeamId) {
        user.teamId = -1;
      }
    }

    if (this.currentActiveTabIndex >= this.teams.length) {
      this.currentActiveTabIndex--;
    }

    this.currentTeamId = this.teams[this.currentActiveTabIndex].id;
    this.userShowMode = 'all';

  }

  updateTeamName(event) {
    const inputValue = event.currentTarget.value;
    /** Don't change the Team name if the name field left blank */
    if (inputValue !== '') {
      this.teams[this.currentActiveTabIndex].name = event.currentTarget.value;
    }
  }

  selectUser(user) {
    if (user.teamId === -1) {
      user.teamId = this.currentTeamId;
    } else {
      user.teamId = -1;
    }
  }


  onCancel() {
    this.dialog.dismiss();
  }

  onSubmit() {
    const userIdsByTeamIds = {};

    for (const user of this.usersList) {
      if (user.teamId !== -1) {
        if (!userIdsByTeamIds[user.teamId]) {
          userIdsByTeamIds[user.teamId] = [];
        }
        userIdsByTeamIds[user.teamId].push(user.id);
      }
    }

    const teams = [];
    for (const team of this.teams) {
      team.participantIds = userIdsByTeamIds[team.id] || [];
      teams.push({id: team.id, name: team.name, participantIds: team.participantIds, colorIndex: team.colorIndex});
    }

    this.dialog.close({lastTeamId: this.teams[this.teams.length - 1].id, teams});
  }
}
